import { createSlice } from '@reduxjs/toolkit';
import MemberServices from '../services/MemberService';
import CommonUtil from '../common/CommonUtil';
import { SPECIAL_LEAGUES_MAP } from '../common/Foundation';
import Constants from '../common/Constants';

export const TopLeagueSlice = createSlice({
  name: 'TopLeagueSlice',
  initialState: {
    loading: false,
    hasErrors: false,
    topLeagues: [],
  },
  reducers: {
    getTopLeagues: state => {
      state.loading = true
    },
    getTopLeaguesSuccess: (state, { payload }) => {
      state.loading = false
      state.hasError = false
      state.topLeagues = payload
    },
    getTopLeaguesFailure: state => {
      state.loading = false
      state.hasErrors = true
    },
  },
});

export const {
  getTopLeagues,
  getTopLeaguesSuccess,
  getTopLeaguesFailure,
} = TopLeagueSlice.actions

export default TopLeagueSlice.reducer;

export const fetchTopLeagues = () => {
  return async (dispatch, getState) => {
    try {
      const country = 'US', v = '';
      const response = await MemberServices.getCompactSpecialLeagues(country, v).then(res => {
        let result = [];
        if (res && res.data && res.data.length > 0) {
          result = res.data;
          if (window.env.isB2B && (CommonUtil.isEsportOnlyByBrand() || CommonUtil.isSpecifyEsportsOnlyByBrand())) {
            result = result.filter(league => league.sportId === Constants.ESPORT_ID);
          }
          result = CommonUtil.sortSportsPriority(result, getState().SportsSlice.options.sportsSorting)
        }
        return result;
      }).catch(e => {
        dispatch(getTopLeaguesFailure());
      });
      dispatch(getTopLeaguesSuccess(response))
    } catch (error) {
      dispatch(getTopLeaguesFailure())
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/slices/TopLeagueSlice.js